import React from "react";
import {Column} from "react-vcomponents";
import {BaseComponent} from "react-vextensions";
import {ES, Observer} from "web-vcore";
import {GetMap} from "../../Server/DB/maps.js";
import {MapUI} from "./MapUI.js";
import {GetMapState} from "../../Store/main/maps/$mapState.js";
import {mapStatesInitialized} from "../../Utils/AutoRuns/InitForNewlyLoadedMap.js";
import {observer_mgl} from "mobx-graphlink";

export const MapUIWaitMessage = ((props: {message: string})=>{
	const {message} = props;
	return (
		<div style={ES({
			display: "flex", alignItems: "center", justifyContent: "center", flex: 1, fontSize: 25,
			//textShadow: "#000 0px 0px 1px,   #000 0px 0px 1px,   #000 0px 0px 1px, #000 0px 0px 1px,   #000 0px 0px 1px,   #000 0px 0px 1px",
			color: "white",
			textShadow: "-1px -1px 0 #000, 1px -1px 0 #000, -1px 1px 0 #000, 1px 1px 0 #000",
		})}>
			{message}
		</div>
	);
});

export const MapUIWrapper = observer_mgl((props: {mapID: string})=>{
	const {mapID} = props;
	const map = GetMap(mapID);
	if (map == null) return <MapUIWaitMessage message="Map is private/deleted."/>;

	const mapState = GetMapState(mapID);
	if (mapState == null || !mapStatesInitialized.has(mapID)) return <MapUIWaitMessage message="Initializing map metadata..."/>;
	
	return (
		<MapUI {...{map, mapState}}/>
	);
});